// FastAPI reports errors in the body's `detail`, but in two different shapes:
//
//   400 (and friends) → a plain string:  "Username or email already registered."
//   422 (validation)  → an array of objects, one per field that failed:
//                       [{ loc: ['body', 'subscription'], msg: "Input should be ..." }]
//
// Pages that only handled the string case rendered the array as
// "An unexpected error occurred", which told the user nothing about which field was
// wrong. errorLines() flattens either shape into a list of readable strings.

// 'confirm_password' -> 'Confirm password'. `loc` starts with the request part
// ('body', 'query', ...), which is noise to the person filling in the form.
const fieldLabel = (loc) => {
  if (!Array.isArray(loc)) return '';
  const name = loc.filter((part) => typeof part === 'string' && part !== 'body').pop();
  if (!name) return '';
  const words = name.replace(/_/g, ' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
};

export const errorLines = (detail, fallback = 'An unexpected error occurred. Please try again.') => {
  if (typeof detail === 'string' && detail.trim()) {
    return [detail.trim()];
  }

  if (Array.isArray(detail)) {
    const lines = detail
      .map((item) => {
        const msg = typeof item?.msg === 'string' ? item.msg.trim() : '';
        if (!msg) return '';
        const label = fieldLabel(item?.loc);
        return label ? `${label}: ${msg}` : msg;
      })
      .filter(Boolean);

    if (lines.length) return lines;
  }

  return [fallback];
};

// Same thing for an axios error object, wherever the caller has the error rather than
// an already-unpacked response.
export const errorLinesFrom = (err, fallback) =>
  errorLines(err?.response?.data?.detail, fallback);

export default errorLines;
